import { render } from "./BookingList.vue?vue&type=template&id=5548d0c3&scoped=true"
import script from "./BookingList.vue?vue&type=script&lang=js"
export * from "./BookingList.vue?vue&type=script&lang=js"

import "./BookingList.vue?vue&type=style&index=0&id=5548d0c3&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5548d0c3"]])

export default __exports__